import React, {FC, useEffect, useState, useCallback, useRef, useMemo} from 'react'
import {PageLink, PageTitle} from '../../_metronic/layout/core'
import {useQueryClient} from 'react-query'
import {KTCard, toAbsoluteUrl} from '../../_metronic/helpers'
import {KTCardBody} from '../../_metronic/helpers'
import {KTSVG} from '../../_metronic/helpers'
import axios from 'axios'
import {Maintable} from '../tables/Maintable'
import {Updateinvoice} from '../dashboard/modals/Updateinvoice'
import {PaymentHistory} from './modals/PaymentHistory'
import {Updatecustomer} from './modals/Updatecustomer'
import {Addcustomer} from './modals/Addcutomer'
import {Deletecustomer} from './modals/Deletecustomer'
import {
  useAllcustomers2,
  useCustomersSummary,
  useTopCustomers,
  useDeleteCustomer,
} from '../contextProviders/Atomqueryprovider'
import LoadingBar from 'react-top-loading-bar'
import {Column} from 'react-table'
import {useAuth} from '../../app/modules/auth'
import {useWindowWidth} from '@react-hook/window-size/throttled'
import dayjs from 'dayjs'
import * as XLSX from 'xlsx'
import io from 'socket.io-client'
import CountUp from 'react-countup'
import {ItemsSummary} from '../topdashboard/ItemsSummary'
import {useDashboard} from '../contextProviders/Dashboardcontext'

import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import relativeTime from 'dayjs/plugin/relativeTime'
import calendar from 'dayjs/plugin/calendar'
import localizedFormat from 'dayjs/plugin/localizedFormat'
import isBetween from 'dayjs/plugin/isBetween'

dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.extend(relativeTime)
dayjs.extend(calendar)
dayjs.extend(localizedFormat)
dayjs.extend(isBetween)

const API_URL = process.env.REACT_APP_API_URL
const CURRENCY_APP = process.env.REACT_APP_CURRENCY || 'KSH'
const OPENING_TIME = process.env.REACT_APP_OPENING_TIME || ' 00:00:00'
const socket = io('possocket.27mirrors.com')

const truncate = require('truncate')

const addCommas = (num: any) => {
  if (num === undefined || num === null || num === '') return '0'
  const numValue = typeof num === 'string' ? parseFloat(num) : num
  if (isNaN(numValue)) return '0'
  return numValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}

interface UnpaidInvoice {
  invoice_id: string
  total_amount: number
  amount_tendered: number
  unpaid_amount: number
  date_recorded: string
  status: string
  payment_type_name: string
  created_by_user: string
}

interface CustomerData {
  customer_id: number
  customer_firstname?: string
  customer_secondname?: string
  customer_name: string
  customer_phone_number: string
  customer_email: string
  total_sales_amount: number
  total_amount_paid: number
  total_unpaid_amount: number
  unpaid_invoices_count: number
  unpaid_invoices: UnpaidInvoice[]
}

const paymentsBreadcrumbs: Array<PageLink> = [
  {
    title: 'Customers',
    path: '/customer-payments',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

const Payments: FC = () => {
  const queryClient = useQueryClient()
  const refloadingbar: any = useRef(null)
  const myRefsearch: any = useRef()
  const {currentUser} = useAuth()
  const [paginationsize, setPaginationsize] = useState<number>(10)
  const [startlimit, setStartlimit] = useState<number>(0)
  const [itemto_order, setItemto_order] = useState<string>('total_unpaid_amount')
  const [desorasc, setDesorasc] = useState<string>('DESC')
  const [search_item, setSearch_item] = useState<string>('%')
  const [movetofirstpage, setMovetofirstpage] = useState<boolean>(false)
  const [showUpdateModal, setShowUpdateModal] = useState(false)
  const [showHistoryModal, setShowHistoryModal] = useState(false)
  const [selectedInvoice, setSelectedInvoice] = useState<any>(null)
  const [selectedInvoiceId, setSelectedInvoiceId] = useState<string>('')
  const [pageCount, setPageCount] = useState<number>(0)

  const [modalshow, setModalshow] = useState(false)
  const [modalcustomerupdateshow, setModalcustomerupdateshow] = useState(false)
  const [modalshowdelete, setModalshowdelete] = useState(false)
  const [statedeletingcustomer, setStatedeletingcustomer] = useState(false)
  const [customertodelete, setCustomertodelete] = useState<CustomerData | null>(null)
  const [customertoUpdate, setCustomertoUpdate] = useState<CustomerData | null>(null)
  const [cannotDeletecustomer, setCannotDeletecustomer] = useState<boolean>(false)

  const [statusnow, setStatusnow] = useState<boolean>(false)
  const [statusnow2, setStatusnow2] = useState<boolean>(false)
  const [summaryDatanew, setSummaryDatanew] = useState<any>([])
  const {showDashboard} = useDashboard()
  const onlyWidth = useWindowWidth()

  const sortedSummaryAsc = useMemo(() => {
    return [...summaryDatanew].sort((a: any, b: any) =>
      a.date_recordednow > b.date_recordednow ? 1 : -1
    )
  }, [summaryDatanew])

  const sortedSummaryDesc = useMemo(() => {
    return [...summaryDatanew].sort((a: any, b: any) =>
      a.date_recordednow > b.date_recordednow ? -1 : 1
    )
  }, [summaryDatanew])

  const {
    isLoading,
    data: allcustomersdata,
    refetch,
    status: allcustomersstatus,
  } = useAllcustomers2(
    Number(currentUser?.user_id),
    startlimit,
    paginationsize,
    itemto_order,
    desorasc,
    search_item,
    true
  )

  const {mutateAsync: deletecustomersmutateAsync} = useDeleteCustomer(
    customertodelete?.customer_id ?? 0,
    Number(currentUser?.user_id)
  )

  const {
    isLoading: summaryloading,
    isSuccess: summarysuccess,
    data: summarydata,
    isRefetching: summaryrefetching,
    refetch: summaryrefetch,
  } = useCustomersSummary(
    Number(currentUser?.user_id),
    new Date(dayjs().startOf('month').subtract(7, 'days').format('YYYY-MM-DD') + OPENING_TIME),
    new Date(dayjs().add(1, 'month').startOf('month').format('YYYY-MM-DD') + OPENING_TIME),
    0,
    7,
    '%'
  )

  const {refetch: topcustomersrefetch} = useTopCustomers(
    Number(currentUser?.user_id),
    dayjs().startOf('month').format('YYYY-MM-DD'),
    dayjs().endOf('month').format('YYYY-MM-DD'),
    10,
    'total_sales'
  )

  useEffect(() => {
    if (!summaryrefetching && summarysuccess && summarydata) {
      setSummaryDatanew(summarydata?.data || [])
      setStatusnow(true)
      setStatusnow2(true)
    }
    if (summaryrefetching) {
      setStatusnow2(false)
    }
  }, [summarydata, summarysuccess, summaryrefetching])

  const downloadReport = async (): Promise<void> => {
    try {
      await refloadingbar.current?.continuousStart()
      if (!allcustomersdata?.data?.customers) return

      const wb = XLSX.utils.book_new()
      const exportData = allcustomersdata.data.customers.map((customer: CustomerData) => ({
        'Customer Name': customer.customer_name,
        Phone: customer.customer_phone_number,
        'Total Sales': customer.total_sales_amount,
        'Total Paid': customer.total_amount_paid,
        'Balance Owed': customer.total_unpaid_amount,
        'Unpaid Invoices': customer.unpaid_invoices_count,
      }))

      const ws = XLSX.utils.json_to_sheet(exportData)
      XLSX.utils.book_append_sheet(wb, ws, 'Customer Payments')
      XLSX.writeFile(wb, `Customer_Payments_${dayjs().format('YYYY-MM-DD')}.xlsx`)
    } catch (error) {
      console.error('Error generating report:', error)
    } finally {
      refloadingbar.current?.complete()
    }
  }

  useEffect(() => {
    refetch()
  }, [itemto_order, desorasc, search_item, startlimit, paginationsize])

  socket.on('update', () => {
    refetch()
    summaryrefetch()
  })

  const handleUpdatePayment = (invoice: any) => {
    setSelectedInvoice(invoice)
    setShowUpdateModal(true)
  }

  const handleViewHistory = (invoice_id: string) => {
    setSelectedInvoiceId(invoice_id)
    setShowHistoryModal(true)
  }

  const showcustomerupdateModal = (customer: CustomerData) => {
    setCustomertoUpdate(customer)
    setModalcustomerupdateshow(true)
  }

  const showModaldelete = (customer: CustomerData) => {
    setCustomertodelete(customer)
    setModalshowdelete(true)
  }

  const deleteselectedcustomer = async () => {
    setStatedeletingcustomer(true)
    try {
      const response = await deletecustomersmutateAsync()
      if (response.data.status === 'success') {
        refetch()
        summaryrefetch()
        setModalshowdelete(false)
      } else {
        setCannotDeletecustomer(true)
      }
    } catch (error) {
      setCannotDeletecustomer(true)
    } finally {
      setStatedeletingcustomer(false)
    }
  }

  const showModal = () => {
    setModalshow(true)
  }

  const columns: ReadonlyArray<Column<CustomerData>> = useMemo(
    () => [
      {
        Header: () => null,
        id: 'expander',
        Cell: ({row}: any) => (
          <span {...row.getToggleRowExpandedProps()}>
            <i className={`fa fa-chevron-${row.isExpanded ? 'down' : 'right'} text-primary`}></i>
          </span>
        ),
      },
      {
        Header: 'Customer',
        accessor: 'customer_name',
        Cell: ({row}: any) => (
          <div className='d-flex align-items-center'>
            <div className='symbol symbol-50px me-3'>
              <div className='symbol-label bg-light'>
                <img
                  src={toAbsoluteUrl('/media/icons/duotune/communication/com006.svg')}
                  alt=''
                  className='h-75'
                />
              </div>
            </div>
            <div className='d-flex justify-content-start flex-column'>
              <span className='text-dark fw-bolder fs-6'>
                {truncate(row.original.customer_name, 25)}
              </span>
              <span className='text-muted fw-bold fs-7'>{row.original.customer_phone_number}</span>
            </div>
          </div>
        ),
      },
      {
        Header: 'Total Sales',
        accessor: 'total_sales_amount',
        className: 'text-end',
        Cell: ({value}: any) => (
          <span className='text-dark fw-bolder fs-6'>
            {addCommas(Number(value).toFixed(2))} {CURRENCY_APP}
          </span>
        ),
      },
      {
        Header: 'Paid',
        accessor: 'total_amount_paid',
        className: 'text-end',
        Cell: ({value}: any) => (
          <span className='text-success fw-bolder fs-6'>
            {addCommas(Number(value).toFixed(2))} {CURRENCY_APP}
          </span>
        ),
      },
      {
        Header: 'Balance',
        accessor: 'total_unpaid_amount',
        className: 'text-end',
        Cell: ({value}: any) => (
          <span className='text-danger fw-bolder fs-6'>
            {addCommas(Number(value).toFixed(2))} {CURRENCY_APP}
          </span>
        ),
      },
      {
        Header: 'Actions',
        id: 'actions',
        className: 'text-end',
        Cell: ({row}: any) => (
          <div className='d-flex justify-content-end flex-shrink-0'>
            <button
              className='btn btn-icon btn-light-primary btn-active-primary btn-sm me-1'
              title='Update Customer'
              onClick={() => showcustomerupdateModal(row.original)}
            >
              <KTSVG path='/media/icons/duotune/art/art005.svg' className='svg-icon-3' />
            </button>
            <button
              className='btn btn-icon btn-light-danger btn-active-danger btn-sm me-1'
              title='Delete Customer'
              onClick={() => showModaldelete(row.original)}
            >
              <KTSVG path='/media/icons/duotune/general/gen027.svg' className='svg-icon-3' />
            </button>
            {row.original.unpaid_invoices_count > 0 && (
              <button
                className='btn btn-icon btn-light-success btn-active-success btn-sm me-1'
                title='Record Payment'
                onClick={() =>
                  handleUpdatePayment({
                    ...row.original.unpaid_invoices[0],
                    customer_name: row.original.customer_name,
                  })
                }
              >
                <KTSVG path='/media/icons/duotune/finance/fin003.svg' className='svg-icon-3' />
              </button>
            )}
            <button
              className='btn btn-icon btn-light-info btn-active-info btn-sm'
              title='Payment History'
              onClick={() => handleViewHistory(row.original.customer_id.toString())}
            >
              <KTSVG path='/media/icons/duotune/general/gen012.svg' className='svg-icon-3' />
            </button>
          </div>
        ),
      },
    ],
    []
  )

  const subColumns: ReadonlyArray<Column<UnpaidInvoice>> = useMemo(
    () => [
      {
        Header: 'Invoice ID',
        accessor: 'invoice_id',
        Cell: ({value}: any) => <span className='text-primary fw-bolder'>{value}</span>,
      },
      {
        Header: 'Amount',
        accessor: 'total_amount',
        className: 'text-end',
        Cell: ({value}: any) => <span>{addCommas(Number(value).toFixed(2))}</span>,
      },
      {
        Header: 'Owed',
        accessor: 'unpaid_amount',
        className: 'text-end',
        Cell: ({row}: any) => (
          <span className='text-danger fw-bolder'>
            {addCommas(
              (row.original.status === 'NOT PAID'
                ? row.original.total_amount
                : row.original.unpaid_amount
              ).toFixed(2)
            )}
          </span>
        ),
      },
      {
        Header: 'Status',
        accessor: 'status',
        className: 'text-end',
        Cell: ({value}: any) => (
          <span className={`badge badge-light-${value === 'PARTIAL' ? 'warning' : 'danger'}`}>
            {value}
          </span>
        ),
      },
      {
        Header: 'Actions',
        id: 'actions',
        className: 'text-end',
        Cell: ({row}: any) => (
          <div className='d-flex justify-content-end flex-shrink-0'>
            <button
              className='btn btn-icon btn-light-success btn-active-success btn-sm me-1'
              title='Record Payment'
              onClick={() => handleUpdatePayment(row.original)}
            >
              <KTSVG path='/media/icons/duotune/finance/fin003.svg' className='svg-icon-3' />
            </button>
            <button
              className='btn btn-icon btn-light-info btn-active-info btn-sm'
              title='Payment History'
              onClick={() => handleViewHistory(row.original.invoice_id)}
            >
              <KTSVG path='/media/icons/duotune/general/gen012.svg' className='svg-icon-3' />
            </button>
          </div>
        ),
      },
    ],
    []
  )

  const handlesearchKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      const value = (event.target as HTMLInputElement).value
      setSearch_item(value ? value + '%' : '%')
      setStartlimit(0)
      setMovetofirstpage(true)
    }
  }

  const handleinputs = (e: any) => {
    if (e.target.value === '') {
      setSearch_item('%')
      setStartlimit(0)
      setMovetofirstpage(true)
    }
  }

  return (
    <>
      <LoadingBar color='#009ef7' ref={refloadingbar} />
      <PageTitle breadcrumbs={paymentsBreadcrumbs}>Customer Payments History</PageTitle>

      {showDashboard && (
        <div className='row g-5 g-xl-8'>
          <div className='col-xl-4'>
            <ItemsSummary
              className='card-xl-stretch mb-xl-8'
              chartColor='primary'
              chartHeight='120px'
              cardName='T.Sales'
              chartName='Customer Sales'
              statusnow={statusnow}
              statusnow2={statusnow2}
              yaxisHeight={Math.max(
                ...summaryDatanew.map((x: any) => x.total_sales_amount || 0),
                0
              )}
              chartCategories={sortedSummaryAsc.map((x: any) =>
                dayjs(x.date_recordednow).format('LL')
              )}
              chartData={sortedSummaryAsc.map((x: any) => x.total_sales_amount)}
              values={
                <div className='fs-2 fw-bolder d-block'>
                  <CountUp
                    className='text-primary'
                    end={sortedSummaryDesc[0]?.total_sales_amount || 0}
                    duration={2}
                    decimals={2}
                    separator=','
                  />{' '}
                  <sup className='fs-6 text-primary'>{CURRENCY_APP}</sup>
                </div>
              }
              values2={
                <span className='fw-bold d-block fs-7 mt-2 text-muted'>
                  <table>
                    <tbody>
                      {sortedSummaryDesc[1]?.date_recordednow && (
                        <tr>
                          <td>
                            <span className='badge badge-light-primary'>
                              {dayjs(sortedSummaryDesc[1].date_recordednow).calendar(null, {
                                sameDay: '[Today]',
                                lastDay: '[Yesterday]',
                                sameElse: 'DD/MM/YYYY',
                              })}
                            </span>
                          </td>
                          <td>
                            <span className='h-20px border-gray-200 border-start mx-2'></span>
                            <CountUp
                              className='text-bold text-muted'
                              end={sortedSummaryDesc[1].total_sales_amount}
                              duration={2}
                              decimals={2}
                              separator=','
                            />{' '}
                            <sup className='text-muted'>{CURRENCY_APP}</sup>
                          </td>
                        </tr>
                      )}
                      {sortedSummaryDesc[2]?.date_recordednow && (
                        <tr>
                          <td>
                            <span className='badge badge-light-primary'>
                              {dayjs(sortedSummaryDesc[2].date_recordednow).calendar(null, {
                                sameDay: '[Today]',
                                lastDay: '[Yesterday]',
                                sameElse: 'DD/MM/YYYY',
                              })}
                            </span>
                          </td>
                          <td>
                            <span className='h-20px border-gray-200 border-start mx-2'></span>
                            <CountUp
                              className='text-bold text-muted'
                              end={sortedSummaryDesc[2].total_sales_amount}
                              duration={2}
                              decimals={2}
                              separator=','
                            />{' '}
                            <sup className='text-muted'>{CURRENCY_APP}</sup>
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </span>
              }
            />
          </div>
          <div className='col-xl-4'>
            <ItemsSummary
              className='card-xl-stretch mb-xl-8'
              chartColor='danger'
              chartHeight='120px'
              cardName='T.Unpaid'
              chartName='Customer Unpaid Amounts'
              statusnow={statusnow}
              statusnow2={statusnow2}
              yaxisHeight={Math.max(
                ...summaryDatanew.map((x: any) => x.total_unpaid_amount || 0),
                0
              )}
              chartCategories={sortedSummaryAsc.map((x: any) =>
                dayjs(x.date_recordednow).format('LL')
              )}
              chartData={sortedSummaryAsc.map((x: any) => x.total_unpaid_amount)}
              values={
                <div className='fs-2 fw-bolder'>
                  <CountUp
                    className='text-danger'
                    end={sortedSummaryDesc[0]?.total_unpaid_amount || 0}
                    duration={2}
                    decimals={2}
                    separator=','
                  />{' '}
                  <sup className='text-danger fs-6'>{CURRENCY_APP}</sup>
                </div>
              }
              values2={
                <span className='fw-bold d-block fs-7 mt-2 text-muted'>
                  <table>
                    <tbody>
                      {sortedSummaryDesc[1]?.date_recordednow && (
                        <tr>
                          <td>
                            <span className='badge badge-light-danger'>
                              {dayjs(sortedSummaryDesc[1].date_recordednow).calendar(null, {
                                sameDay: '[Today]',
                                lastDay: '[Yesterday]',
                                sameElse: 'DD/MM/YYYY',
                              })}
                            </span>
                          </td>
                          <td>
                            <span className='h-20px border-gray-200 border-start mx-2'></span>
                            <CountUp
                              className='text-bold text-muted'
                              end={sortedSummaryDesc[1].total_unpaid_amount}
                              duration={2}
                              decimals={2}
                              separator=','
                            />{' '}
                            <sup className='text-muted'>{CURRENCY_APP}</sup>
                          </td>
                        </tr>
                      )}
                      {sortedSummaryDesc[2]?.date_recordednow && (
                        <tr>
                          <td>
                            <span className='badge badge-light-danger'>
                              {dayjs(sortedSummaryDesc[2].date_recordednow).calendar(null, {
                                sameDay: '[Today]',
                                lastDay: '[Yesterday]',
                                sameElse: 'DD/MM/YYYY',
                              })}
                            </span>
                          </td>
                          <td>
                            <span className='h-20px border-gray-200 border-start mx-2'></span>
                            <CountUp
                              className='text-bold text-muted'
                              end={sortedSummaryDesc[2].total_unpaid_amount}
                              duration={2}
                              decimals={2}
                              separator=','
                            />{' '}
                            <sup className='text-muted'>{CURRENCY_APP}</sup>
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </span>
              }
            />
          </div>
          <div className='col-xl-4'>
            <ItemsSummary
              className='card-xl-stretch mb-5 mb-xl-8'
              chartColor='info'
              chartHeight='120px'
              statusnow={statusnow}
              statusnow2={statusnow2}
              cardName='T.Customers'
              isCurrency={false}
              chartName='Customer Growth'
              yaxisHeight={Math.max(...summaryDatanew.map((x: any) => x.unique_customers || 0), 0)}
              chartCategories={sortedSummaryAsc.map((x: any) =>
                dayjs(x.date_recordednow).format('LL')
              )}
              chartData={sortedSummaryAsc.map((x: any) => x.unique_customers)}
              values={
                <div className='fs-2 fw-bolder'>
                  <CountUp
                    className='text-info'
                    end={sortedSummaryDesc[0]?.unique_customers || 0}
                    duration={2}
                    decimals={0}
                    separator=','
                  />
                </div>
              }
              values2={
                <span className='fw-bold d-block fs-7 mt-2 text-muted'>
                  <table>
                    <tbody>
                      {sortedSummaryDesc[1]?.date_recordednow && (
                        <tr>
                          <td>
                            <span className='badge badge-light-info'>
                              {dayjs(sortedSummaryDesc[1].date_recordednow).calendar(null, {
                                sameDay: '[Today]',
                                lastDay: '[Yesterday]',
                                sameElse: 'DD/MM/YYYY',
                              })}
                            </span>
                          </td>
                          <td>
                            <span className='h-20px border-gray-200 border-start mx-2'></span>
                            <CountUp
                              className='text-bold text-muted'
                              end={sortedSummaryDesc[1].unique_customers}
                              duration={2}
                              decimals={0}
                              separator=','
                            />
                          </td>
                        </tr>
                      )}
                      {sortedSummaryDesc[2]?.date_recordednow && (
                        <tr>
                          <td>
                            <span className='badge badge-light-info'>
                              {dayjs(sortedSummaryDesc[2].date_recordednow).calendar(null, {
                                sameDay: '[Today]',
                                lastDay: '[Yesterday]',
                                sameElse: 'DD/MM/YYYY',
                              })}
                            </span>
                          </td>
                          <td>
                            <span className='h-20px border-gray-200 border-start mx-2'></span>
                            <CountUp
                              className='text-bold text-muted'
                              end={sortedSummaryDesc[2].unique_customers}
                              duration={2}
                              decimals={0}
                              separator=','
                            />
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </span>
              }
            />
          </div>
        </div>
      )}

      <KTCard>
        <KTCardBody className='py-4'>
          <div className='row mt-4'>
            <div className='col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start'>
              <div className='mb-2'>
                <h3 className='fw-bolder my-2'>Customer Payments History</h3>
              </div>
            </div>
            <div className='col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end'>
              <div className='mb-2'>
                <div className='d-flex align-items-center position-relative my-1'>
                  <KTSVG
                    path='/media/icons/duotune/general/gen021.svg'
                    className='svg-icon-1 position-absolute me-4 top-0 end-0 mt-3 text-primary'
                  />
                  <input
                    type='text'
                    className='form-control form-control-solid w-250px ps-5 pe-12'
                    placeholder='Search Customer...'
                    ref={myRefsearch}
                    onChange={handleinputs}
                    onKeyDown={handlesearchKeyDown}
                  />
                </div>
              </div>
            </div>
          </div>

          <div className='row'>
            <div className='col-sm-12 col-md-12 d-flex align-items-center justify-content-center justify-content-md-start'>
              <div className='mb-2 me-auto'>
                <a
                  className='btn btn-info btn-sm mb-2 me-2'
                  href='#'
                  onClick={(e: React.MouseEvent<HTMLAnchorElement>) => {
                    e.preventDefault()
                    downloadReport()
                  }}
                >
                  <KTSVG path='/media/icons/duotune/files/fil002.svg' className='svg-icon-1' />
                  {onlyWidth <= 576 ? '↓' : 'Download Report'}
                </a>
              </div>
              <div className='mb-2' style={{display: 'inline-grid', gridTemplateColumns: '1fr'}}>
                <a
                  className='btn btn-success btn-sm mb-2 me-2'
                  href='#'
                  onClick={(e: React.MouseEvent<HTMLAnchorElement>) => {
                    e.preventDefault()
                    showModal()
                  }}
                  title={onlyWidth <= 576 ? 'Add Customer' : ''}
                >
                  <KTSVG
                    path='/media/icons/duotune/communication/com006.svg'
                    className='svg-icon-1'
                  />
                  {onlyWidth <= 576 ? '+' : 'Add Customer'}
                </a>
              </div>
            </div>
          </div>

          <Maintable
            columndata={columns}
            columndata2={subColumns}
            tabledata={allcustomersdata?.data?.customers || []}
            tabledata2={[]}
            table1loaded={allcustomersstatus === 'success'}
            table2loaded={true}
            tablename='Customer Payments'
            tablelength={allcustomersdata?.data?.datalength || 0}
            setPaginationsize={setPaginationsize}
            setstartlimit={setStartlimit}
            paginationsize={paginationsize}
            startlimit={startlimit}
            setServersort={() => {}}
            movetofirstpage={movetofirstpage}
            setMovetofirstpage={setMovetofirstpage}
            pageCount={pageCount}
            setPageCount={setPageCount}
            hiddencolumnsmade={[]}
            filteredsubdata={(row: any) => row.original.unpaid_invoices.length}
            filteredtablesubData={(row: any) => row.original.unpaid_invoices}
          />
        </KTCardBody>
      </KTCard>

      <Addcustomer show={modalshow} handleClose={() => setModalshow(false)} />

      {modalcustomerupdateshow && customertoUpdate && (
        <Updatecustomer
          show={modalcustomerupdateshow}
          customertoUpdate={customertoUpdate}
          allcustomersrefetch={refetch}
          summaryrefetch={summaryrefetch}
          topcustomersrefetch={topcustomersrefetch}
          handleClose={() => setModalcustomerupdateshow(false)}
        />
      )}

      {modalshowdelete && customertodelete && (
        <Deletecustomer
          show={modalshowdelete}
          deleteselectedcustomer={deleteselectedcustomer}
          customertodelete={customertodelete}
          statedeletingcustomer={statedeletingcustomer}
          cannotDeletecustomer={cannotDeletecustomer}
          handleClose={() => setModalshowdelete(false)}
        />
      )}

      {showUpdateModal && selectedInvoice && (
        <Updateinvoice
          show={showUpdateModal}
          handleClose={() => setShowUpdateModal(false)}
          invoiceupdate={selectedInvoice}
          invoiceData={[]}
          ref={null}
        />
      )}

      {showHistoryModal && (
        <PaymentHistory
          show={showHistoryModal}
          handleClose={() => setShowHistoryModal(false)}
          invoice_id={selectedInvoiceId}
        />
      )}
    </>
  )
}

export default Payments
